export { default } from "./RelatedContent";
